<template>
  <article class="standard">
    <header class="container text-center standard__header mb-y-gutter-sm">
      <h1 class="standard__title heading font-antidote">{{ title }}</h1>
    </header>
    <expand-height>
      <rich-text
        v-if="contactForm.isSubmitted"
        class="container text-center container--narrow"
        standard
      >
        <p>{{ contactForm.submissionMessage }}</p>
        <cta fill small @click.stop.prevent="handleReset">
          reset form
        </cta>
      </rich-text>
      <sanity-blocks
        v-if="content && !contactForm.isSubmitted"
        :blocks="content"
        rich-text
        standard
        class="standard__content"
      />
    </expand-height>
  </article>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'StandardPage',

  props: {
    title: {
      default: undefined,
      type: String
    },
    content: {
      default: undefined,
      type: Array
    }
  },

  computed: {
    ...mapGetters('page', ['getContactForm']),
    contactForm() {
      return this.getContactForm(this.$route) || {}
    }
  },

  methods: {
    ...mapMutations('page', ['resetContactForm']),
    handleReset() {
      this.resetContactForm({ route: this.$route })
    }
  }
}
</script>

<style>
.standard {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
</style>
